var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"jotform",staticStyle:{"min-width":"100%","height":"580px","border":"none"},attrs:{"id":"JotFormIFrame-203443089586160","title":"Customer Onboarding","onload":"window.parent.scrollTo(0,0)","allowtransparency":"true","allowfullscreen":"true","src":"https://form.jotform.com/203443089586160","frameborder":"0","scrolling":"no"}})
}
var staticRenderFns = []

export { render, staticRenderFns }